module.exports = __webpack_public_path__ + "img/loading-25.8f945b83.svg";